import type { ApexOptions } from 'apexcharts'
import type { ChatTimeSeriesData } from '../../../features/engagement/domain/models/chat'
import { buildLineChartOptions, EngagementChartColors, longDateFormatter, type ChartSeriesItem } from '../charts'

export interface ChatLegendState {
  [key: string]: boolean
  activeUsers: boolean
  totalMessages: boolean
  uniqueChatters: boolean
}

export interface ChatLegendItem {
  key: string
  label: string
  color: string
}

const CHAT_COLORS = {
  activeUsers: EngagementChartColors.primary,
  totalMessages: EngagementChartColors.secondary,
  uniqueChatters: EngagementChartColors.tertiary
}

export const CHAT_LEGEND_ITEMS: ChatLegendItem[] = [
  { key: 'activeUsers', label: 'Active Users', color: CHAT_COLORS.activeUsers },
  { key: 'totalMessages', label: 'Total Messages', color: CHAT_COLORS.totalMessages },
  { key: 'uniqueChatters', label: 'Unique Chatters', color: CHAT_COLORS.uniqueChatters }
]

export const CHAT_INITIAL_LEGEND_STATE: ChatLegendState = {
  activeUsers: true,
  totalMessages: true,
  uniqueChatters: true
}

export const getChatChartOptions = (data: ChatTimeSeriesData[], legend: ChatLegendState): ApexOptions => {
  const categories = data.map((d) => d.date)

  const series: ChartSeriesItem[] = []

  if (legend.activeUsers) {
    series.push({
      name: 'Active Users',
      data: data.map((d) => d.activeUsers),
      color: CHAT_COLORS.activeUsers
    })
  }

  if (legend.totalMessages) {
    series.push({
      name: 'Total Messages',
      data: data.map((d) => d.messages),
      color: CHAT_COLORS.totalMessages
    })
  }

  if (legend.uniqueChatters) {
    series.push({
      name: 'Unique Chatters',
      data: data.map((d) => d.uniqueChatters),
      color: CHAT_COLORS.uniqueChatters
    })
  }

  return buildLineChartOptions({
    series,
    categories,
    tooltipHeaderFormatter: longDateFormatter
  })
}
